import { useCallback, type FC } from 'react';

import {
  AutoplayModifyButton,
  AutoplayModifyButtonProps,
} from '@pp/core/src/components/game/autoplayV2/buttons/modifyButton/AutoplayModifyButton';
import { CurrencyConnected } from '@pp/core/src/components/currency/CurrencyConnected';
import { Bets } from '../../../../config/bets';
import { useValidBetInputValue } from '../../../gameGrid/hooks/useValidBetInputValue';
import { useCrashAutoplaySlice } from '../../../../store/slices/crashAutoplay/selectors';
import { crashAutoplayActions } from '../../../../store/slices/crashAutoplay/slice';
import { Logger } from '@pp/core/src/logger/Logger';
import { useCoreDispatch } from '@pp/core/src/store/CoreStore';

export interface AutoplayModifyButtonConnectedProps extends Pick<AutoplayModifyButtonProps, 'addOn' | 'disabled'> {
  betId: Bets;
}

export const CrashAutoplayModifyButtonConnected: FC<AutoplayModifyButtonConnectedProps> = ({
  betId,
  addOn,
  disabled,
}) => {
  const dispatch = useCoreDispatch();
  const { betInputAmount } = useValidBetInputValue(betId);

  const maxRoundsLimit = useCrashAutoplaySlice.getAutoplayMaxRoundsLimit(betId);
  const roundsLeft = useCrashAutoplaySlice.getRemainingCount(betId);
  const isRoundsLimitReached = maxRoundsLimit === roundsLeft;


  const addRounds = useCallback(
    (): void => {
      dispatch(crashAutoplayActions.addRounds({ betsSpot: betId, value: addOn }));
      Logger.logEvent('autoplay_modify', {
        additional: addOn.toString(),
      });
    },
    [dispatch]
  );

  return (
    <AutoplayModifyButton
      addOn={addOn}
      totalBet={<CurrencyConnected value={betInputAmount * addOn} />}
      onClick={addRounds}
      disabled={isRoundsLimitReached || disabled}
    />
  );
};